// Guid
export function UUID() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

export function isEqualGuidString(a, b) {
  var aGuidString = a.replace(/-/g, "").toLowerCase();
  var bGuidString = b.replace(/-/g, "").toLowerCase();
  return aGuidString === bGuidString;
}

export const isEmptyGuidStr = (str) => {
  if (
    str != undefined &&
    str != "" &&
    str != "00000000000000000000000000000000"
  ) {
    return false;
  }
  return true;
};

export const convertLineBreakSymbolReverse = (str) => {
  return str.replace(/<br\/>/g, '\n');
};

export const convertLineBreakSymbol = (str) => {
  const reg = /\\n\\n|\\n/g
  return str.replace(reg, "<br/>");
};

export const lineBreakSymbol = (str) => {
  return str.replace(/\\n\\n|\\n/g, "\n");
};

export const jsonBreakSymbol = (str) => {
  // return str.replace(/[\[\]{}]/g, '');
  return str.split('[').join('').split(']').join('').split('{').join('').split('}').join('').split("**").join("")
};

export const markdownSymbol = (str) => {
  return str.replace(/\*\*|###|##|#|```markdown|markdown|```|---/g, '')
}

export const clearNotJsonBreakSymbol = (str) => {
  return str.replace(/```json|```|json/g, "")
};

export const clearLineBreakSymbol = (str) => {
  return str.replace(/\\n\\n|\\n/g, "")
};

// 处理特殊的SC字段内的换行符，与prompt的规则对应，SC字段内的换行符为"***###"
export function removeBeforeFirstBracket(input) {  
  const firstBracketIndex = input.indexOf('[');  
  const lastBracketIndex = input.lastIndexOf(']');  
  let str = ''
  if (firstBracketIndex === -1 || lastBracketIndex === -1 || firstBracketIndex >= lastBracketIndex) {
    str = input
  } else {
    str = input.slice(firstBracketIndex, lastBracketIndex + 1)
  }
  return str
} 

export const markdownSymbolTransfomer = (str) => {
  // 正则表达式匹配不同级别的标题  
  const pattern = /^(#+)(.*?)\n/gm;  
      
  // 替换函数，根据#的数量返回不同级别的圆点  
  function replaceHeader(match, p1, p2) {  
      const level = p1.length; // 获取#的数量  
      let dot = '. '; // 默认使用实心圆点  
      if (level > 1) {  
          dot = '。'.repeat(level - 1); // 对于二级及以上标题使用空心圆点  
      }  
      return dot + ' ' + p2 + '\n'; // 保留标题文本并添加换行符  
  }  
    
  // 使用replace方法和替换函数来转换标题  
  const convertedText = str.replace(pattern, replaceHeader);  
  return convertedText;  
};

// params {title: string, body: string}
export const browserNotification = (params) => {
  if (window.Notification) {
    // 支持
    Notification.requestPermission(function (status) {
      if (status === "granted") {
        var notification = new Notification(params.title, {
          body: params.body,
        });
        notification.onshow = function () {
          setTimeout(notification.close.bind(notification), 5000);
        };
      } else {
        console.error("Notification is not granted.");
      }
    });
  } else {
    // 不支持
    console.error("Notification is not supported.");
  }
};

// compare version
export const compareVersion = (a, b) => {
  var aVersions = a.split(".");
  var bVersions = b.split(".");
  // 先设定版本号为3位，否则不比较视为相同
  // 版本号大，返回1；小，返回-1；
  if (aVersions.length == 3 && bVersions.length == 3) {
    for (var i = 0; i < aVersions.length; i++) {
      if (aVersions[i] > bVersions[i]) {
        return 1;
      } else if (aVersions[i] < bVersions[i]) {
        return -1;
      }
    }
  } else {
    return 0;
  }
};

// file size
export function bytesToSize(size) {
  if (size < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = size.toFixed(2) + "B";
  } else if (size < 0.1 * 1024 * 1024) {
      // 小于0.1MB，则转化成KB
      size = (size / 1024).toFixed(2) + "KB";
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
      // 小于0.1GB，则转化成MB
      size = (size / (1024 * 1024)).toFixed(2) + "MB";
  } else {
      // 其他转化成GB
      size = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }

  // 转成字符串
  let sizeStr = size + "",
      // 获取小数点处的索引
      index = sizeStr.indexOf("."),
      // 获取小数点后两位的值
      dou = sizeStr.substr(index + 1, 2);

  // 判断后两位是否为00，如果是则删除00
  if (dou == "00") return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);

  return size;
}

//進入全屏
// 参数为this.$refs.xxx.$el，有时this.$refs.xxx是数组，需要判断类型取数组里的对象，再取$el
export function launchFullscreen(element) {
  //此方法不可以在異步任務中執行，否則火狐無法全屏
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.oRequestFullscreen) {
    element.oRequestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen();
  } else {
    console.log("This browser does not support full screen.");
  }
}

export function sleep(time){
  return new Promise((resolve) => setTimeout(resolve, time));
}